<gridster [options]="options">
   <gridster-item
      (window:resize)="onResize($event)"
      *ngFor="let brickId of brickInstanceIds$ | async"
      [item]="brickId | brickIdToGridsterConfig$: false | async"
   >
      <samweb-brick-container [brickInstanceId]="brickId"></samweb-brick-container>
   </gridster-item>
</gridster>
